module.exports = __webpack_public_path__ + "img/brackets-curly.c3191cb2.svg";